import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  subscriptionActions,
  subscriptionSelectors
} from '../../store/modules/subscription';

const useUserCard = () => {
  const dispatch = useDispatch();
  const card = useSelector(subscriptionSelectors.selectCard);

  useEffect(() => {
    if (card) return;
    dispatch(subscriptionActions.fetchSubscriptionHistory());
  }, [card]);

  return card;
};

export default useUserCard;
